const getters = {
  GET_USER: state => {
    return state.current_user
  },
  getRouterLinks: state => {
    return state.routerLinks
  },
  getSettings(state) {
    return state.settings
  },
  getGrowthBook(state) {
    return state.growthBook
  },
  getContractNumberAndTariff(state) {
    return state.contractNumberAndTariff
  },
  getInstructions(state) {
    return state.instructions
  },
  getTimezones(state) {
    return state.timezones
  },
  getSurveyData(state) {
    return state.npsUserData
  }
}

export default getters
